import React from "react";
import PropTypes from "prop-types";
import { Label } from "@conserveit/blocks";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import Moment from "moment";
import DynamicFormComponent from "./DynamicFormComponent";
import Validator from "./Validator";

@connect(
  (state) => ({
    isFormDisabled: state.reportGenerator.isFormDisabled,
  }),
  null,
  null,
  { forwardRef: true }
)
export default class DateRange extends DynamicFormComponent {
  static propTypes = {
    isFormDisabled: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      startDate: Moment().subtract(6, "days"),
      endDate: Moment(),
      isFormValid: true,
    };
  }

  // react-datepicker works with Date objects; state is kept as moment.
  handleStartDateChange = (date) => {
    this.setState({ startDate: date && Moment(date), isFormValid: true });
  };

  handleEndDateChange = (date) => {
    this.setState({ endDate: date && Moment(date), isFormValid: true });
  };

  validate = () => {
    const { startDate, endDate } = this.state;

    if (!startDate || !endDate || endDate.diff(startDate, "days") > 30) {
      this.setState({ isFormValid: false });
      return false;
    }
    return true;
  };

  getSelectedValues = () => {
    return {
      startDate: this.state.startDate.format("YYYY-MM-DD"),
      endDate: this.state.endDate.format("YYYY-MM-DD"),
    };
  };

  render() {
    require("react-datepicker/dist/react-datepicker.css");

    return (
      <div>
        <Label>Date Range</Label>
        <div>
          <Validator
            isValid={this.state.isFormValid}
            errMsg="Range cannot be greater than 30 days"
          >
            <DatePicker
              selected={this.state.startDate && this.state.startDate.toDate()}
              selectsStart
              startDate={this.state.startDate && this.state.startDate.toDate()}
              endDate={this.state.endDate && this.state.endDate.toDate()}
              todayButton="Select today"
              dateFormat="dd MMM yyyy"
              isClearable
              disabled={this.props.isFormDisabled}
              onChange={this.handleStartDateChange}
              maxDate={Moment().toDate()}
            />{" "}
            <DatePicker
              selected={this.state.endDate && this.state.endDate.toDate()}
              selectsEnd
              startDate={this.state.startDate && this.state.startDate.toDate()}
              endDate={this.state.endDate && this.state.endDate.toDate()}
              todayButton="Select today"
              dateFormat="dd MMM yyyy"
              isClearable
              disabled={this.props.isFormDisabled}
              onChange={this.handleEndDateChange}
              maxDate={Moment().toDate()}
            />
          </Validator>
        </div>
      </div>
    );
  }
}
